import { render, staticRenderFns } from "./Cedis.vue?vue&type=template&id=2e10032f"
import script from "./Cedis.vue?vue&type=script&lang=js"
export * from "./Cedis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports